import React, { forwardRef } from 'react';

import { ReactComponent as ClearIcon } from '../../../icons/close.svg';
import { ReactComponent as SearchIcon } from '../../../icons/search.svg';

import { Input } from '../input/Input';

export const SearchInput = forwardRef(
  ({ label, name, value, placeholder, onChange, style }, ref) => {
    return (
      <Input
        label={label}
        name={name}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        clearIcon={ClearIcon}
        icon={SearchIcon}
        style={style}
        filled
        className="search-input"
      />
    );
  }
);
